(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('patfileupload', {
      restrict: 'E',
      bindings: {
        patientid: '<?'
      },
      template: `
        <fileupload parentsave="vm.savewithsigning(filedata)"
            label="Hinaufladen mit Vidierung"
            color="success"
            clientid="vm.patientid">
        </fileupload>
        <fileupload parentsave="vm.savewithoutsigning()"
            label="Hinaufladen ohne Vidierung"
            color="warning"
            clientid="vm.patientid">
        </fileupload>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog',
        function ($log, File, Rlog) {
          let vm = this;
          vm.savewithsigning = savewithsigning;
          vm.savewithoutsigning = savewithoutsigning;

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.clientid) &&
              angular.isDefined(changes.clientid.currentValue) &&
              changes.clientid.currentValue.length > 0) {
              vm.patientid = changes.clientid.currentValue;
              vm.clientid = changes.clientid.currentValue;
            }
          };

          function savewithsigning(filedata) {
            File.$find(filedata.fileid).$then(function (file) {
              $log.debug('save filewithsigning: ', file);
              file.scanstatus = 'assigned';
              file.signedoff = 'false';
              file.doccat = 'patient';
              file.active = true;
              file.$save();
            }, function (err) {
              $log.error('fileupload metdata could not be retrieved for further editing: ', err);
              Rlog.error('vcdms.file', 'patfileupload', 'fileupload metdata could not be retrieved for further editing', {});
            });


          }

          function savewithoutsigning() {
            // do nothing, defaults are set for patient fileupload without vidierung
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
